<template>
  <v-dialog :value="open" max-width="441" width="441" style="border-radius: 32px !important;" :persistent="true">
    <v-card class="dialog-box">
      <div class="header-container">
        <span id="loginTitle">{{ $t("Activate2FA") }}</span>
        <span class="twoFaMessage" id="loginMessage">{{ $t("Activate2FAAuthenticationMessage") }}</span>
      </div>

      <div class="qr-code-container">
        <img v-if="qrCode" :src="qrCode" alt="Image icon" class="data-image" />
      </div>

      <div style="margin-bottom: 10px; text-align: start;">
        <span class="login-input-label">{{ $t("Key") }}</span>
        <input
          v-model="key"
          type="text"
          id="key"
          class="twoFaInput"
          :class="{ fieldErrorInput: !key }"
        />
      </div>

      <v-card-actions class="card-buttons-container">
        <management-button
          type="cancel"
          :label="$t('Cancel')"
          :disabled="loading || cancelButtonIsDisabled"
          @buttonClick="closeDialog"
        /> -->

        <management-button
          type="execute"
          :label="$t('Confirm')"
          :disabled="!(key && secret)"
          :is-loading="loading"
          @buttonClick="confirmAuthenticate"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import utils from "@/utils";
import ManagementButton from "@/components/Management/ManagementButton";


export default {
  name: "ActivateTwoAuthenticationDialog",
  components: { ManagementButton },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      key: null,
      qrCode: null,
      secret: null,
      cancelButtonIsDisabled: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.is2faRequired();
    }, 500);
  },

  mounted() {
    if (this.open) {
      this.generateQRCode();
    }
  },

  watch: {
    open(value) {
      if (value) {
        this.generateQRCode();
      }
      this.is2faRequired();
    },
  },

  methods: {
    ...mapMutations(["setTwoAuthentication"]),
    ...mapActions(["createQRCode", "saveQRCode", "editUserByID"]),

    is2faRequired(){
      this.cancelButtonIsDisabled = localStorage.getItem('2fa_required') === 'true' && localStorage.getItem('user_has_2fa') === 'null';
    },

    async generateQRCode() {
      let result = await this.createQRCode();
      this.qrCode = result.qr_code;
      this.secret = result.secret;
    },

    async confirmAuthenticate() {
      try {
        this.loading = true;
        let dataToSend = { secret: this.secret, key: this.key };
        await this.saveQRCode(dataToSend);
        let userId = this.$store.getters.currentUserID;
        let dataToSendEditUser = { secret_2fa: this.secret };
        await this.editUserByID({
          id: userId,
          updatedData: dataToSendEditUser
        });
        this.$toasted.global.toast_success(
          this.$i18n.t("ActivateAuthenticateSuccessfully")
        );
        this.setTwoAuthentication(this.secret);
        this.$emit("activateAuthenticate");
        this.closeDialog();
      } catch (e) {
        let errorHandle = utils.errorHandler(e);
        if (typeof errorHandle === "string") {
          this.$toasted.global.toast_error(errorHandle);
        }
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    closeDialog() {
      this.key = null;
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.input-key {
  width: 30%;
  height: 32px;
  color: #515358;
  background-color: transparent;
  border: 1px solid #d7dadc;
  border-radius: 2px;
  padding: 0 8px;
}

.data-image {
  width: 300px;
  object-fit: cover;
}

.dialog-box {
  height: 720px;
  background-color: rgb(255, 255, 255);
  border-radius: 32px;
  padding: 32px;
}

.twoFaInput {
  background: rgba(195, 195, 195, 0.25);
}

.header-container {
  display: flex;
  flex-direction: column;
}

#loginTitle,
.login-input-label {
  width: 100% !important;
  text-align: start;
}

.qr-code-container {
  margin: 40px 0;
}

.card-buttons-container {
  margin-top: 40px;
  padding: 0 !important;
}

.card-buttons-container >>> #management-button {
  background: transparent !important;
  box-shadow: none !important;
  font-size: 15px !important;
  padding: 0 !important;
}

.card-buttons-container >>> #management-button.cancel {
  color: rgba(35, 30, 70, 0.50);
}

.card-buttons-container >>> #management-button.execute {
  color: #231E46;
}

@media only screen and (max-height: 800px) {
  .qr-code-container {
    margin: 30px 0;
  }

  .dialog-box {
    height: 675px;
  }
}

@media only screen and (max-height: 750px) {
  .dialog-box {
    height: 630px;
  }

  .data-image {
    width: 200px;
    object-fit: cover;
  }

  .qr-code-container {
    margin: 30px 0;
  }

  #loginTitle {
    font-size: 20px;
    line-height: 20px;
  }
}

@media only screen and (max-height: 700px) {
  .dialog-box {
    height: 450px;
  }

  .data-image {
    width: 120px;
    object-fit: cover;
  }

  .qr-code-container {
    margin: 30px 0;
  }

  .twoFaInput {
    height: 60px;
    padding: 24px;
  }
}

@media only screen and (max-height: 525px) {
  .dialog-box {
    height: 375px;
  }

  .data-image {
    width: 100px;
    object-fit: cover;
  }

  .qr-code-container {
    margin: 20px 0;
  }

  .twoFaInput {
    height: 40px;
    padding: 16px;
  }
}

@media only screen and (max-height: 425px) {
  .dialog-box {
    height: 300px;
    padding: 16px;
  }

  .data-image {
    width: 100px;
    object-fit: cover;
  }

  .qr-code-container {
    margin: 15px 0;
  }

  .twoFaInput {
    height: 30px;
    padding: 10px;
  }

  .card-buttons-container {
    margin-top: 15px;
  }

  .twoFaMessage {
    display: none;
  }
}

.v-dialog__content >>> .v-dialog {
  border-radius: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Navbar/UserWindow/ActivateTwoAuthenticationDialog.vue